import '/assets/styles/sections/event-categories.scss';
import { useMemo } from 'react';
import propTypes from 'prop-types';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Slider from '/views/partials/slider';

// Context
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';

// Dummy Data
import rawCategories from '/data/dummy/event-categories-data';

const EventCategories = ({ id }) => {	
	const { desktop } = useBreakpoints();

	const categories = useMemo(() => rawCategories || [null, null, null, null, null, null, null, null], [rawCategories])

	return (
		<section className="section eventcategories">
			<div className="eventcategories-wrap wrapper narrow">
				<h2 className="eventcategories-title">
					<Icon name="confusion" className="title-icon" /> Nasıl Bir Etkinlik Arıyorsun?
				</h2>

				{desktop ?
					<ul className="eventcategories-list">
						{categories.map((category, nth) => (
							<li className="list-item" key={category?.key ?? nth}>
								<Link className="eventcategories-category" href="search" params={{ term: category.searchTerm }}>
									<Img
										cover
										src={category.image}
										className="category-image" />
									<strong className="category-title">{category.title}</strong>
								</Link>
							</li>
						))}
					</ul>
					:
					<Slider
						className="eventcategories-slider"
						id={`${id ?? 'eventcategories'}-slider`}
						pagination
						params={{
							slidesPerView: 2,
							slideTag: 'li',
							wrapperTag: 'ul',
						}}>
						{categories.map((category, nth) => (
							<Link
								key={category?.key ?? nth}
								className="eventcategories-category"
								href="home">
								<Img
									cover
									src={category.image}
									className="category-image" />
								<strong className="category-title">{category.title}</strong>
							</Link>
						))}
					</Slider>
				}
			</div>
		</section>
	)
}

EventCategories.propTypes = {
	id: propTypes.string,
}

export default EventCategories;